import { CORE_EVENT } from './config'

export default class SEIOnDemand {
    _seiQueue = []
    _baseDts = Infinity
    _timer = 0

    constructor (player) {
      this._player = player
    }

    updateBaseDts (dts) {
      this._baseDts = dts
      this._bootCheckEmitSEI()
    }

    append (sei) {
      const time = this._baseDts === Infinity ? 0 : (sei.dts - this._baseDts) / 1000

      // 前2s的sei信息提前抛出去
      if (time < 2) {
        this._player?.emit(CORE_EVENT.SEI, sei)
        return
      }

      this._seiQueue.push({
        time,
        data: sei
      })
    }

    _bootCheckEmitSEI () {
      if (this._timer) {
        clearInterval(this._timer)
      }

      this._timer = setInterval(this._checkEmitSEI, 25)
    }

    _checkEmitSEI = () => {
      const cTime = this._player?.currentTime || 0

      if (!cTime) return

      let index = -1

      for (let i = 0, len = this._seiQueue.length; i < len; i++) {
        const cSei = this._seiQueue[i]

        if (cSei?.time > cTime) {
          index = i
          break
        }
      }

      if (index < 0) return

      this._seiQueue.splice(0, index)

      let sei = this._seiQueue[0]

      while (sei) {
        if (!sei) break

        const delta = sei?.time - cTime

        if (delta >= 0.05) {
          break
        }

        this._seiQueue.shift()
        this._player?.emit(CORE_EVENT.SEI, sei.data)
        sei = this._seiQueue[0]
      }
    }

    destroy () {
      clearInterval(this._timer)
      this._player = null
      this._seiQueue = []
    }
}
